import { createAction } from '@reduxjs/toolkit';
import { ISkill } from '../../../../dto';
import { ACT_SET, MN_SKILLS, TYPE_ELEMENT } from '../../../../common';

export const setSkill = createAction<ISkill>(
  `${MN_SKILLS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
